import { Phone } from "lucide-react";

export default function WhatsAppButton() {
  return (
    <a
      href="https://wa.me/923XXXXXXXXX?text=Hi%20I%20need%20a%20plumber"
      target="_blank"
      rel="noopener noreferrer"
      className="whatsapp-float"
    >
      <Phone />
    </a>
  );
}